"use client"
import { createContext, ReactNode, useContext, useState } from "react"

type Mode = "main" | "panel"

interface SidebarMenuProviderProps {
  children: ReactNode;
}

const SidebarMenuContext = createContext<{
  mode: Mode
  setMode: (m: Mode) => void
}>({} as any)

export function SidebarMenuProvider({ children }: SidebarMenuProviderProps) {
  const [mode, setMode] = useState<Mode>("main")

  return (
    <SidebarMenuContext.Provider value={{ mode, setMode }}>
      {children}
    </SidebarMenuContext.Provider>
  )
}

export const useSidebarMenu = () => useContext(SidebarMenuContext)
